import { ca } from '@cian/analytics';

/**
 * Клик на кнопку Удалить
 */
export function trackCommentDelete() {
  ca('event', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'delete_comment',
    label: '',
  });
}
